/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Harine",
  title: "Hi there, I'm Harine",
  subTitle: emoji(
    "I'm a final year B.Tech CSE student, currently working as an SDE Intern at Amazon. I'm passionate about app development & new tech."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1XapOErs2iffG8p_iXVdK9Y_9bQXUG1MO/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/harine19",
  linkedin: "https://www.linkedin.com/in/harine-vidyasekaran/",
  gmail: "harinehlc@gmail.com",
  medium: "https://medium.com/@harinehlc",
  stackoverflow: "https://stackoverflow.com/users/22143866/harine-vidyasekaran",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "My Skills",
  subTitle: "Full stack development, Competitive programming, Artificial Intelligence",
  skills: [
    emoji(
      "⚡ Develop end-to-end Full stack Web & Mobile apps"
    ),
    emoji("⚡ Integrate Machine learning into apps to make life easier"),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Spring boot",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "REST APIs",
      fontAwesomeClassname: "fas fa-link"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Machine learning",
      fontAwesomeClassname: "fas fa-brain"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section
// Education

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Amrita Vishwa Vidyapeetham",
      logo: require("./assets/images/amrita.png"),
      subHeader: "Bachelor of Technology in Computer Science & Engineering",
      duration: "Sep 2021 - Apr 2025",
      descBullets: [
        "Ranked 1st in the department with an SGPA of 9.42",
        "Research scholar with 1 IEEE published research paper and conference"
      ]
    },
    {
      schoolName: "Chettinad Vidyashram",
      logo: require("./assets/images/cv.jpeg"),
      subHeader: "PCMC - Phy Chem Math & Computer Science",
      duration: "June 2019 - July 2021",
      descBullets: [
        "Scored a 482/500 or 96.4% in the 12th Board Exam",
        "Part of a FIITJEE integrated programme for competitive exams training"
      ]
    },
    {
      schoolName: "HLC International",
      logo: require("./assets/images/hlc.png"),
      subHeader: "International GCSE Cambridge Syllabus",
      duration: "June 2012 - Apr 2019",
      descBullets: [
        "School Vice Captain & Karthavyam Diploma Holder",
        "A* grades in 10th International GCSE Exam"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Artificial intelligence",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "SDE Intern",
      company: "Amazon",
      companylogo: require("./assets/images/amazon.png"),
      date: "Jan 2025 – Jun 2025",
      descBullets: [
        "Working with the E-reader products team (Amazon Kindle)",
        "Software Development Engineer role (6-month)"
      ]
    },
    {
      role: "SWE Intern",
      company: "Protean",
      companylogo: require("./assets/images/protean.png"),
      date: "Aug 2024 – Sep 2024",
      descBullets: [
        "Designed an API with backend integration for a mobile app.",
        "Tech stack: Python, Flask, RestAPI, Swagger."
      ]
    },
    {
      role: "SWE Intern",
      company: "Fidelity Investments",
      companylogo: require("./assets/images/fidelity.png"),
      date: "May 2024 – Aug 2024",
      descBullets: [
        "Worked as a full stack developer with Angular + TS + Springboot.",
        "Performed end-to-end unit testing with Jest."
      ]
    },
    {
      role: "AWS Cloud Captain",
      company: "Amazon Web Services",
      companylogo: require("./assets/images/aws.jpg"),
      date: "March 2024 – Feb 2025",
      descBullets: [
        "Selected as an AWS Captain where only 60 leaders were chosen worldwide in 2024.",
        "Founded an AWS Club."
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "My major development projects",
  projects: [
    {
      image: require("./assets/images/tree.jpeg"),
      projectName: "`Breathe`- ML powered app",
      projectDesc: "Leveraged real-time machine learning to detect and reduce pollution levels by incorporating a government API to get instant air quality changes; Developed as part of an NITT 32-hour hackathon.",
      footerLink: [
        {
          name: "Visit Repository",
          url: "http://github.com/Harine19/NITPragyan"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/todo.jpg"),
      projectName: "Task management app",
      projectDesc: "Created a to-do list app with an interactive user interface using JavaScript, HTML, and CSS. Incorporated functionalities such as creation, deletion, remainders and over 10+ features.",
      footerLink: [
        {
          name: "Visit Repository",
          url: "http://github.com/Harine19/Todo-list-webapp"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications & Awards",

  achievementsCards: [
    {
      title: "Code for GovTech Winner",
      subtitle:
        "Won the C4GT hackathon with a cash prize of 1 Lakh + Internship in an SWE role.",
      image: require("./assets/images/c4gtswag.jpg"),
      imageAlt: "open src",
      footerLink: [
        {name: "View Certificate", url: "https://drive.google.com/file/d/1M7qHAao0J_oKvKrgVu6BywCrbHzGVgzg/view?usp=sharing"},
      ]
    },
    {
      title: "AWS Cloud Captain",
      subtitle:
        "Lead at AWS through a highly selective process- 60 leaders were selected across the globe.",
      image: require("./assets/images/awscc1.jpg"),
      imageAlt: "Cloud captain",
      footerLink: [
        {name: "View Award",url: "https://www.linkedin.com/posts/harinevidyasekaran_aws-cloudcaptain-techcommunity-activity-7187081206457405440-2XIl?utm_source=share&utm_medium=member_desktop"},
        {name: "View Certificate", url: "https://drive.google.com/file/d/1Af6uvrnE45E5lHbPO1f_b64zww3eMTO4/view?usp=sharing"},
        {name: "Acceptance mail", url: "https://drive.google.com/file/d/13gBjUfM1Zh2LUpH49MSGdHsaoKyN0XAA/view?usp=sharing"},
      ]
    },
    {
      title: "1st Rank Holder",
      subtitle:
        "Ranked 1st in the Department of Computer Science and Engg. with an SGPA of 9.42",
      image: require("./assets/images/1strank.png"),
      imageAlt: "1st rank",
      footerLink: [
        {
          name: "View Award",
          url: "https://www.linkedin.com/posts/harinevidyasekaran_honored-to-be-awarded-as-the-1st-rank-holder-activity-7158413017037082626-a3_9?utm_source=share&utm_medium=member_desktop"
        }
      ]
    },
    {
      title: "IEEE Research Scholar",
      subtitle:
        "Paper:`Impact of Diet and Nutritional Factors in Controlling Type 2 Diabetes Through ML`",
      image: require("./assets/images/ieeelogo.png"),
      imageAlt: "Research scholar",
      footerLink: [
        {name: "View Publication", url: "https://ieeexplore.ieee.org/document/10421052"},
      ]
    },
    {
      title: "IEEE Conference",
      subtitle:
        "Paper: Research was into deepfake detection using a hybrid deep learning model",
      image: require("./assets/images/conference.png"),
      imageAlt: "Research scholar",
      footerLink: [
        {name: "View Certificate", url: "https://drive.google.com/file/d/1x2GnVRJm00vAiiGvXHkSIVvQFpsjTiNu/view?usp=sharing2"},
      ]
    },
    {
      title: "UI/UX Design hackathon: 1st Place Winner",
      subtitle:
        "Designed a CyberSecurity Website UI/UX and won a cash prize of 5000₹",
      image: require("./assets/images/uiux.jpg"),
      imageAlt: "UIUX winner",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://drive.google.com/file/d/10wUi4DFm8_q6-ndrAWAFPi1vgqv4feQQ/view?usp=drive_link"
        },
      ]
    },
    {
      title: "Adzap National contest: 3rd Place Winner",
      subtitle:
        "Triumphed in an All-India Adzap contest and won a cash prize of 2000₹",
      image: require("./assets/images/adzap.jpg"),
      imageAlt: "Adzap",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://drive.google.com/file/d/1kAMml_W2VLeFUBwRuzadjoB2eSfze6Oc/view?usp=drive_link"
        }
      ]
    },
    {
      title: "WPM Wars Speed Typing: 1st Place Winner",
      subtitle: "Contested in a National level at speed typing and won a cash prize of 3000₹",
      image: require("./assets/images/wpmwars.png"),
      imageAlt: "Words Per Minute = WPM",
      footerLink: [
        {name: "View Certificate", url: "https://drive.google.com/file/d/1CEr69VxbBfN4luJCLNxiRdG2-N-d0VcZ/view?usp=sharing"},
      ]
    },
    {
      title: "Xartup Fellowship",
      subtitle: "Awarded entry into the Xartup programme for entrepreneurial pursuits.",
      image: require("./assets/images/xartup.png"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "View Certificate", url: "https://drive.google.com/file/d/1JhG8mcKMc55AJALR9_oJjY6HNQFHNr5E/view?usp=sharing"},
        {
          name: "Acceptance mail",
          url: "https://drive.google.com/file/d/1ay68-wtixMbrBwCQx_aX70MfT7ndQzj0/view?usp=sharing"
        }
      ]
    },
    {
      title: "Children's Book Author",
      subtitle: "Authored a children's book to increase sustainability awareness",
      image: require("./assets/images/author.png"),
      imageAlt: "Author",
      footerLink: [
        {name: "Publication", url: "https://www.amazon.in/Trash-Violence-Harine-Vidyasekaran/dp/B06XSSMDLN"},
        {name: "View Article", url: "https://www.newindianexpress.com/chennai/2017/Mar/17/these-kids-are-change-makers-1582555.html"},
      ] 
    },
    {
      title: "Karthavyam Diploma",
      subtitle: "6-month diploma program launched by the Ashoka Innovation Fund",
      image: require("./assets/images/karth.png"),
      imageAlt: "Diploma",
      footerLink: [
        {name: "View Certificate", url: "https://drive.google.com/file/d/16Th1XsQOUIHQhxIFL17BnA6nwdQdhH4-/view?usp=drive_link"},
        {name: "View Website", url: "https://www.karthavyam.com/diploma/2016/10/18/garbage-thrown-on-the-roads-and-plots/"},
      ] 
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "Exploring my love for writing, merged with the things I develop",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://medium.com/@harinehlc/the-hidden-reality-of-type-2-diabetes-revealing-solutions-beyond-medication-d66f34cab08e",
      title: "The Hidden Reality of Type 2 Diabetes: Revealing Solutions Beyond Medication",
      description:
        "Delve into the pivotal role of Glycemic Index for diabetes management and how making dietary shifts gives one the potential to completely control or even reverse the disease."
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I love video editing & presenting to an audience"
  ),

  talks: [
    {
      title: "What is Identity and Access Management?",
      subtitle: "AWS Cloud Captain C3 cohort Video",
      //slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://youtu.be/Bn4OjlSYepc?si=HtDCmOZCyA-qSVaF"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Currently, I'm actively looking for full-time roles in SDE, if you find my profile fit, please feel free to reach out thru my email/linkedin.",
  email_address: "harinehlc@gmail.com",
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
